const local = '_PROVIDER_ORGAOS_FOLLOWAIR_'
import Vue from 'vue'

var update = false

export default {
	methods: {
		_GET_ORGAO: function (callback) {
			this._httpGet('/Orgao/get_orgao', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerOrgaoUpdate: function () {
			//console.log("update orgao")
			// ESTADOS
			this._GET_ORGAO(function (lista) {
				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerOrgao: function (callback) {
			//console.log("update orgao", update)

			if (!update) {
				update = true
				this._GET_ORGAO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			// se existir config do cliente
			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(sessionStorage.getItem(local)))
			} else {
				this._GET_ORGAO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}